var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRealEstate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_236_5548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6259 18.627 23.9981 11.9971 23.999C5.37206 23.999 -0.000959639 18.6259 5.14575e-07 11.999C-0.00191979 5.37216 5.3711 0 11.999 0C18.627 0 24 5.37312 24 12Z",
    fill: "#09847C",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 18.1667H5.33337C5.06004 18.1667 4.83337 17.9401 4.83337 17.6667C4.83337 17.3934 5.06004 17.1667 5.33337 17.1667H18.6667C18.94 17.1667 19.1667 17.3934 19.1667 17.6667C19.1667 17.9401 18.94 18.1667 18.6667 18.1667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4668 17.6666H5.4668L5.50013 9.64656C5.50013 9.07989 5.76013 8.55324 6.2068 8.20657L10.8735 4.57323C11.5335 4.0599 12.4601 4.0599 13.1268 4.57323L17.7935 8.1999C18.2335 8.54657 18.5001 9.08656 18.5001 9.64656V17.6666H17.5001V9.65323C17.5001 9.3999 17.3801 9.15324 17.1801 8.99324L12.5135 5.36657C12.2135 5.13323 11.7935 5.13323 11.4868 5.36657L6.82013 8.99991C6.62013 9.15324 6.50013 9.3999 6.50013 9.65323L6.4668 17.6666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 18.1666H10.3334C10.06 18.1666 9.83337 17.9399 9.83337 17.6666V15.3333C9.83337 14.5066 10.5067 13.8333 11.3334 13.8333H12.6667C13.4934 13.8333 14.1667 14.5066 14.1667 15.3333V17.6666C14.1667 17.9399 13.94 18.1666 13.6667 18.1666ZM10.8334 17.1666H13.1667V15.3333C13.1667 15.0599 12.94 14.8333 12.6667 14.8333H11.3334C11.06 14.8333 10.8334 15.0599 10.8334 15.3333V17.1666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 12.6666H9.00004C8.36004 12.6666 7.83337 12.1399 7.83337 11.4999V10.4999C7.83337 9.85992 8.36004 9.33325 9.00004 9.33325H10.3334C10.9734 9.33325 11.5 9.85992 11.5 10.4999V11.4999C11.5 12.1399 10.9734 12.6666 10.3334 12.6666ZM9.00004 10.3333C8.90671 10.3333 8.83337 10.4066 8.83337 10.4999V11.4999C8.83337 11.5933 8.90671 11.6666 9.00004 11.6666H10.3334C10.4267 11.6666 10.5 11.5933 10.5 11.4999V10.4999C10.5 10.4066 10.4267 10.3333 10.3334 10.3333H9.00004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12.6666H13.6667C13.0267 12.6666 12.5 12.1399 12.5 11.4999V10.4999C12.5 9.85992 13.0267 9.33325 13.6667 9.33325H15C15.64 9.33325 16.1667 9.85992 16.1667 10.4999V11.4999C16.1667 12.1399 15.64 12.6666 15 12.6666ZM13.6667 10.3333C13.5733 10.3333 13.5 10.4066 13.5 10.4999V11.4999C13.5 11.5933 13.5733 11.6666 13.6667 11.6666H15C15.0933 11.6666 15.1667 11.5933 15.1667 11.4999V10.4999C15.1667 10.4066 15.0933 10.3333 15 10.3333H13.6667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 8.16675C16.3934 8.16675 16.1668 7.94675 16.1668 7.67342L16.1534 6.16675H13.7201C13.4468 6.16675 13.2201 5.94008 13.2201 5.66675C13.2201 5.39341 13.4468 5.16675 13.7201 5.16675H16.6534C16.9268 5.16675 17.1534 5.38674 17.1534 5.66007L17.1734 7.66007C17.1668 7.94007 16.9468 8.16675 16.6668 8.16675C16.6734 8.16675 16.6668 8.16675 16.6668 8.16675Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_236_5548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealEstate);
export default __webpack_public_path__ + "static/media/real_estate.00f29d67125280e297d4acde618065e8.svg";
export { ForwardRef as ReactComponent };